export { default } from './Rating';